import { render } from "./RiesgosRegistro.vue?vue&type=template&id=31584571"
import script from "./RiesgosRegistro.vue?vue&type=script&lang=js"
export * from "./RiesgosRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__